import { API_BASE_URL } from "./client";
import { AuthTokens } from "./types";

export async function authenticateAdmin(
  identifier: string,
  password: string
): Promise<AuthTokens> {
  try {
    const response = await fetch(`${API_BASE_URL}/api/token/`, {
      method: "POST",
      headers: {
        "Content-Type": "application/json",
      },
      body: JSON.stringify({
        username: identifier,
        password,
      }),
    });

    const data = await response.json().catch(() => ({}));

    if (!response.ok) {
      const message =
        (typeof data?.detail === "string" && data.detail) ||
        "Unable to sign in with the provided credentials.";
      throw new Error(message);
    }

    if (!data?.access) {
      throw new Error("Authentication succeeded but no access token was sent.");
    }

    return {
      access: data.access,
      refresh: data.refresh ?? "",
    };
  } catch (error) {
    const message =
      error instanceof Error
        ? error.message
        : "An unexpected error occurred while contacting the server.";
    throw new Error(message);
  }
}

export function clearAuthStorage() {
  localStorage.removeItem("accessToken");
  localStorage.removeItem("refreshToken");
  localStorage.removeItem("adminAuth");
  localStorage.removeItem("adminEmail");
  localStorage.removeItem("adminLoginTime");
}

export function persistAuth(tokens: AuthTokens, email: string) {
  localStorage.setItem("accessToken", tokens.access);
  if (tokens.refresh) {
    localStorage.setItem("refreshToken", tokens.refresh);
  } else {
    localStorage.removeItem("refreshToken");
  }
  localStorage.setItem("adminAuth", "true");
  localStorage.setItem("adminEmail", email);
  localStorage.setItem("adminLoginTime", new Date().toISOString());
}

export type { AuthTokens };

